var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { NavigatorProvider, useNavigator } from 'hx-navigator';
import { useSyncFormWithStore } from 'hx-wizard';
import { FormProvider, useForm } from 'react-hook-form';
import { useDispatch } from 'react-redux';
import { Outlet } from 'react-router-dom';
import { HearingInNoisyPlacesSelect } from '@/components/hearing-in-noisy-places.component';
import { VolumeSelect } from '@/components/volume-select/volume-select.component';
import { HeadphoneCheck } from '@/components/headphone-check/components/headphone-check.component';
import { wizardActions } from '@/store';
import { ConnectHeadphones } from '@/components/connect-headphones.component';
import { AgeSelectComponent } from '@/components/age-select.component';
import { SendResultsComponent } from '@/components/send-results/send-results.component';
export function SetupPage() {
    var form = useForm({
        defaultValues: {
            volume: 50,
        },
    });
    var dispatch = useDispatch();
    useSyncFormWithStore(form, ['wizard', 'form'], wizardActions.update);
    var navigator = useNavigator({
        onComplete: function () { return dispatch(wizardActions.sendData()); },
    });
    return (_jsx(FormProvider, __assign({}, form, { children: _jsx(NavigatorProvider, __assign({}, navigator, { children: _jsx("form", __assign({ onSubmit: form.handleSubmit(navigator.next) }, { children: _jsx(Outlet, {}) })) })) })));
}
export function HearingInNoisyPlacesStep() {
    return _jsx(HearingInNoisyPlacesSelect, {});
}
export function AgeStep() {
    return _jsx(AgeSelectComponent, {});
}
export function SendResultsStep() {
    return _jsx(SendResultsComponent, {});
}
export function ConnectHeadphoneStep() {
    return _jsx(ConnectHeadphones, {});
}
export function HeadphoneCheckStep() {
    return _jsx(HeadphoneCheck, {});
}
export function VolumeStep() {
    return _jsx(VolumeSelect, {});
}
export default SetupPage;
